import LoadingView from './src/loadingView.vue';

/* istanbul ignore next */
LoadingView.install = function(Vue) {
    Vue.component(LoadingView.name, LoadingView);
};

export default LoadingView;